/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Transfer_Payer_UnconfiguredInputs */

const fr_api_transfer_payer_unconfigured = /** @type {(inputs: Api_Transfer_Payer_UnconfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurez un compte donneur d’ordre dans les paramètres avant d’émettre le virement.`)
};

const en_api_transfer_payer_unconfigured = /** @type {(inputs: Api_Transfer_Payer_UnconfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure a payer account in settings before issuing the transfer order.`)
};

/**
* | output |
* | --- |
* | "Configure a payer account in settings before issuing the transfer order." |
*
* @param {Api_Transfer_Payer_UnconfiguredInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_transfer_payer_unconfigured = /** @type {((inputs?: Api_Transfer_Payer_UnconfiguredInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Transfer_Payer_UnconfiguredInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_transfer_payer_unconfigured(inputs)
	return fr_api_transfer_payer_unconfigured(inputs)
});